/**
 * Textos y utilidades del cuadro de conversación fijo (GEN-PX-004, spec §3.3).
 */

export const primerNombre = (nombre) => (nombre ?? '').trim().split(/\s+/)[0] || ''

/** La orquestadora del descriptor (la que enruta); sin ella, el primer agente. Mismo criterio que Home. */
export const orquestadoraDe = (agents = []) => agents.find(a => /orquest|chief of staff/i.test(a.rol ?? '')) ?? agents[0]

/** Jimmy (Chief EKB), si está en el equipo y operativo: preside Saber (GEN-EKB-022). */
export const jimmyDe = (agents = []) => agents.find(a => a.nombre === 'Jimmy' && a.puede_iniciar_chat !== false) ?? null

/** Línea que el aviso de IA añade en Saber tras la frase estándar (mockup Saber-1-mapa.html, .dock .legal). */
export const AVISO_SABER = 'Actúa con tus permisos y deja traza de todo lo que hace.'

/**
 * Texto de ayuda del campo según la zona.
 * zona: 'inicio' | 'conversacion' | 'ficheros' | cualquier otra (texto genérico).
 */
export function textoAyuda({ zona, usuario, enrutadora = 'Anne', agente }) {
  if (zona === 'inicio') {
    const n = primerNombre(usuario)
    return `¿Qué necesitas hoy${n ? `, ${n}` : ''}? ${enrutadora} lo lleva al agente adecuado…`
  }
  if (zona === 'conversacion') return `Escribe a ${agente || enrutadora}…`
  if (zona === 'saber') return `Pídele a ${agente || 'Jimmy'} que la empresa aprenda un documento, una web o una conversación…`
  if (zona === 'ficheros') return 'Pídele a un agente que busque, resuma o archive un fichero…'
  return `Dile a ${enrutadora} qué necesitas y lo lleva al agente adecuado…`
}
